export enum ActionKeys {
    ENTER = 'Enter',
    UP = 'ArrowUp',
    RIGHT = 'ArrowRight',
    DOWN = 'ArrowDown',
    LEFT = 'ArrowLeft',
    TAB = 'Tab',
    ESCAPE = 'Escape',
    BACKSPACE = 'Backspace',
    DELETE = 'Delete',
    SPACE = ' ',
    PAGEUP = 'PageUp',
    PAGEDOWN = 'PageDown',
    END = 'End',
    HOME = 'Home'
}

